export const mockBranches = [
  {
    id: "br1",
    dealer_id: "d1",
    name: "ART Restaurant - Merkez",
    address: "Atatürk Cad. No:45, İstanbul",
    phone: "0212 555 0101",
    email: "merkez@artrestaurant.com",
    contact_person: "Ahmet Yılmaz",
    is_active: true,
    created_at: "2025-01-15T10:00:00+03:00",
  },
  {
    id: "br2",
    dealer_id: "d1",
    name: "ART Restaurant - Sahil",
    address: "Sahil Bulvarı No:120, İstanbul",
    phone: "0212 555 0202",
    email: "sahil@artrestaurant.com",
    contact_person: "Mehmet Demir",
    is_active: true,
    created_at: "2025-02-20T10:00:00+03:00",
  },
  {
    id: "br3",
    dealer_id: "d1",
    name: "ART Restaurant - Havalimanı",
    address: "Havalimanı Terminal 2, İstanbul",
    phone: "0212 555 0303",
    email: "havalimani@artrestaurant.com",
    contact_person: "Ayşe Kaya",
    is_active: false,
    created_at: "2025-03-10T10:00:00+03:00",
  },
];

export const mockRestaurantStock = [
  {
    id: "rs1",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p1",
    product_name: "Dana Bonfile",
    quantity: 25,
    unit: "kg",
    min_stock_level: 5,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs2",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p3",
    product_name: "Tavuk Göğüs",
    quantity: 40,
    unit: "kg",
    min_stock_level: 10,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs3",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p5",
    product_name: "Zeytinyağı",
    quantity: 3,
    unit: "lt",
    min_stock_level: 5,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs4",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p7",
    product_name: "Un",
    quantity: 8,
    unit: "kg",
    min_stock_level: 15,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs5",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p9",
    product_name: "Domates",
    quantity: 18,
    unit: "kg",
    min_stock_level: 8,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs6",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p11",
    product_name: "Peynir (Beyaz)",
    quantity: 0,
    unit: "kg",
    min_stock_level: 5,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs7",
    dealer_id: "d1",
    branch_id: "br2",
    product_id: "p2",
    product_name: "Dana Kıyma",
    quantity: 12,
    unit: "kg",
    min_stock_level: 8,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "rs8",
    dealer_id: "d1",
    branch_id: "br2",
    product_id: "p4",
    product_name: "Somon Fileto",
    quantity: 7,
    unit: "kg",
    min_stock_level: 5,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "rs9",
    dealer_id: "d1",
    branch_id: "br2",
    product_id: "p6",
    product_name: "Pirinç",
    quantity: 25,
    unit: "kg",
    min_stock_level: 10,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "rs10",
    dealer_id: "d1",
    branch_id: "br2",
    product_id: "p8",
    product_name: "Tereyağı",
    quantity: 4,
    unit: "kg",
    min_stock_level: 5,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "rs11",
    dealer_id: "d1",
    branch_id: "br2",
    product_id: "p10",
    product_name: "Soğan",
    quantity: 22,
    unit: "kg",
    min_stock_level: 10,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "rs12",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p12",
    product_name: "Kola (330ml)",
    quantity: 120,
    unit: "adet",
    min_stock_level: 30,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs13",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p13",
    product_name: "Su (500ml)",
    quantity: 5,
    unit: "adet",
    min_stock_level: 20,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "rs14",
    dealer_id: "d1",
    branch_id: "br1",
    product_id: "p14",
    product_name: "Ayran",
    quantity: 45,
    unit: "adet",
    min_stock_level: 25,
    created_at: "2025-06-01T08:00:00+03:00",
    branch_name: "ART Restaurant - Merkez",
  },
];

export const mockStockMovements = [
  {
    id: "sm1",
    dealer_id: "d1",
    stock_id: "rs1",
    branch_id: "br1",
    type: "in",
    quantity: 30,
    description: "Toptan alım - Metro Toptancı",
    created_by: "Ahmet Yılmaz",
    created_at: "2025-07-20T09:00:00+03:00",
    product_name: "Dana Bonfile",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "sm2",
    dealer_id: "d1",
    stock_id: "rs1",
    branch_id: "br1",
    type: "out",
    quantity: 5,
    description: "Mutfak tüketimi - günlük",
    created_by: "Ahmet Yılmaz",
    created_at: "2025-07-22T14:30:00+03:00",
    product_name: "Dana Bonfile",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "sm3",
    dealer_id: "d1",
    stock_id: "rs3",
    branch_id: "br1",
    type: "out",
    quantity: 2,
    description: "Mutfak tüketimi",
    created_by: "Ahmet Yılmaz",
    created_at: "2025-07-22T16:00:00+03:00",
    product_name: "Zeytinyağı",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "sm4",
    dealer_id: "d1",
    stock_id: "rs6",
    branch_id: "br1",
    type: "adjustment",
    quantity: 0,
    description: "Sayım düzeltmesi - stok tükenmiş",
    created_by: "Mehmet Demir",
    created_at: "2025-07-23T08:00:00+03:00",
    product_name: "Peynir (Beyaz)",
    branch_name: "ART Restaurant - Merkez",
  },
  {
    id: "sm5",
    dealer_id: "d1",
    stock_id: "rs7",
    branch_id: "br2",
    type: "in",
    quantity: 15,
    description: "Toptan alım",
    created_by: "Mehmet Demir",
    created_at: "2025-07-21T10:00:00+03:00",
    product_name: "Dana Kıyma",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "sm6",
    dealer_id: "d1",
    stock_id: "rs7",
    branch_id: "br2",
    type: "out",
    quantity: 3,
    description: "Mutfak tüketimi",
    created_by: "Mehmet Demir",
    created_at: "2025-07-22T15:00:00+03:00",
    product_name: "Dana Kıyma",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "sm7",
    dealer_id: "d1",
    stock_id: "rs10",
    branch_id: "br2",
    type: "out",
    quantity: 1,
    description: "Mutfak tüketimi",
    created_by: "Ayşe Kaya",
    created_at: "2025-07-23T11:00:00+03:00",
    product_name: "Tereyağı",
    branch_name: "ART Restaurant - Sahil",
  },
  {
    id: "sm8",
    dealer_id: "d1",
    stock_id: "rs13",
    branch_id: "br1",
    type: "out",
    quantity: 15,
    description: "Restoran satışı",
    created_by: "Ahmet Yılmaz",
    created_at: "2025-07-23T13:00:00+03:00",
    product_name: "Su (500ml)",
    branch_name: "ART Restaurant - Merkez",
  },
];